import script from "./SkipButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SkipButton.vue?vue&type=script&setup=true&lang=js"

import "./SkipButton.vue?vue&type=style&index=0&id=6605d870&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6605d870"]])

export default __exports__